import { Text, Flex, Skeleton } from '@chakra-ui/react';
import { Badge, InteractiveCard } from '@morressier/alembic';
import { faHourglass } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { ISubmissionStatus, SUBMISSION_STATUS_MAP } from 'src/constants';

export const statusBadges = Object.entries(SUBMISSION_STATUS_MAP).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [key]: (
      <Badge size="context" variant={value.variant}>
        <FontAwesomeIcon icon={value.icon || faHourglass} /> {value.label}
      </Badge>
    )
  }),
  {} as Record<ISubmissionStatus, JSX.Element>
);

const SubmissionCard = ({
  title,
  from,
  workflowStatus,
  keywords,
  url
}: {
  title: string;
  url: string;
  from?: string;
  workflowStatus?: string;
  keywords: { text: string }[];
}) => (
  <Link to={url}>
    <InteractiveCard padding={8}>
      <Flex flexDirection="column" gap={4} alignItems="flex-start">
        {statusBadges[workflowStatus as ISubmissionStatus]}
        <Text textStyle="headingGroup">{title}</Text>
        {from && <Text textStyle="textContext">Submitted by {from}</Text>}
        <Flex gap={2} flexWrap="wrap">
          {keywords.map(keyword => (
            <Badge key={keyword.text} size="context" variant="neutral">
              {keyword.text}
            </Badge>
          ))}
        </Flex>
      </Flex>
    </InteractiveCard>
  </Link>
);

const SubmissionCardLoading = () => (
  <InteractiveCard padding={8}>
    <Flex flexDirection="column" gap={4} alignItems="flex-start">
      <Skeleton>
        <Text textStyle="headingGroup">
          Investigating the beliefs of experts on teaching
        </Text>
      </Skeleton>
      <Text textStyle="textContext">
        <Skeleton as="span">Firstname Lastname</Skeleton>
      </Text>
      <Flex gap={2} flexWrap="wrap">
        {Array.from({ length: 3 })
          .fill(0)
          .map((_, i) => (
            <Skeleton key={i}>
              <Badge key={i} size="context" variant="neutral">
                {'.'.repeat(Math.ceil(Math.random() * 20 + 8))}
              </Badge>
            </Skeleton>
          ))}
      </Flex>
    </Flex>
  </InteractiveCard>
);

const SubmissionCardLoader = (props: { length: number }) => (
  <>
    {Array.from({ length: props.length })
      .fill(1)
      .map((_, i) => (
        <SubmissionCardLoading key={i} />
      ))}
  </>
);

export { SubmissionCardLoader };
export default SubmissionCard;
